// @flow
import React from 'react';
import Box from '@waglabs/box';
import Flex from '@waglabs/flex';
import Button from '@waglabs/button';
import Image from '@waglabs/image';
import Text from '@waglabs/text';

import closeButton from './assets/close-button.svg';
import appLogo from './assets/app-logo.svg';
import fiveStarRating from './assets/five-star-rating.svg';

type Props = {
  onCloseClick: (SyntheticMouseEvent<*>) => void,
  onOpenClick: (SyntheticMouseEvent<*>) => void,
  height?: number,
};

export const AppInstallBanner = ({
  height,
  onCloseClick,
  onOpenClick,
}: Props) => (
  <Box
    height={height}
    width={1}
  >
    <Flex
      py="10px"
      px="15px"
      bg="appInstallBannerBackground"
      alignItems="center"
    >
      <Flex
        alignItems="center"
        flex="1"
      >
        <Box>
          <Button
            bg="transparent"
            border="none"
            onClick={onCloseClick}
          >
            <Image
              cursor="pointer"
              src={closeButton}
            />
          </Button>
        </Box>
        <Box
          mr="10px"
          ml="10px"
        >
          <Box
            borderRadius="5px"
          >
            <Image
              height="60px"
              borderRadius="10px"
              src={appLogo}
            />
          </Box>
        </Box>
        <Box>
          <Flex
            flexDirection="column"
          >
            <Text
              fontFamily="body"
              fontWeight="bold"
              color="medGray"
              m="0"
              lineHeight={0}
            >
              WagWalking!
            </Text>
            <Text
              m="0"
              mb="-2px"
              mt="5px"
              color="gray"
              fontSize={2}
              fontFamily="body"
              lineHeight={0}
            >
              Wag Labs!
            </Text>
            <Box>
              <Image
                src={fiveStarRating}
              />
            </Box>
            <Text
              m="0"
              mt="-2px"
              color="medGray"
              fontFamily="body"
              fontSize={2}
              lineHeight={0}
            >
              Free
            </Text>
          </Flex>
        </Box>
      </Flex>
      <Box>
        <Button
          bg="transparent"
          border="none"
          onClick={onOpenClick}
        >
          <Text
            m="0"
            fontFamily="body"
            color="linkBlue"
            lineHeight={0}
          >
            Open
          </Text>
        </Button>
      </Box>
    </Flex>
  </Box>
);

AppInstallBanner.defaultProps = {
  height: 80,
};
